// Import Assets
import uniswap from '../assets/uniswap.png';
import compound from '../assets/compound.png';
import aave from '../assets/aave.png';
import netflixcollection from '../assets/netflixcollection.png';
import nftgallery from '../assets/nftgallery.png';
import sortingvisualizer from '../assets/sortingvisualizer.png';
import netflixclone from '../assets/netflixclone.png';
import lofiapp from '../assets/lofiapp.png';
import icotoken from '../assets/icotoken.png';
import mint2 from '../assets/mint2.png';

const Projects = () => {
    return (
        <section className="projects">
            <h2>My Projects</h2>

            <div className="projects__cards">

                <div className="projects__card">
                    <h3>Morpheus - A.I NFT Minting application</h3>
                    <img src={mint2} alt="Uniswap Swap Page" />
                    <p>An Application where users can create A-I generated artworks by writing a description, using stable diffusion model and can store those images on IPFS (InterPlanetary File System).</p>

                    <a href="https://morpheus-ai-minting.vercel.app/" target="_blank" className="button">Site</a>
                    <a href="https://github.com/utkarsh-1602/Morpheus-AIminting" target="_blank" className="button">github</a>
                </div>

                <div className="projects__card">
                    <h3>NFT Collection</h3>
                    <img src={netflixcollection} alt="Uniswap Swap Page" />
                    <p>Created my own NFT Collection, where users can mint the NFT's. There are only 20 NFT's and each of them is Unique. users should be able to mint 1 NFT with 1 Transaction. Whitelisted user's have 5 mins presale time before the actual sale starts, where they are Guaranteed 1 NFT per Transaction.
                    </p>

                    <a href="https://nft-collection-2022-453psdp68-utkarsh-1602.vercel.app/" target="_blank" className="button">Site</a>
                    <a href="https://github.com/utkarsh-1602/NFT-Collection-2022" target="_blank" className="button">github</a>
                </div>

                <div className="projects__card">
                    <h3>NFT Gallery</h3>
                    <img src={nftgallery} alt="Compound Landing Page" />
                    <p>Created my NFT Gallery, where users can fetch NFT's for a specific collection address or from user's account address, through a NFT MarketPlace.
                    </p>

                    <a href="https://utkarshs-nftgallery2023.vercel.app/" target="_blank" className="button">Site</a>
                    <a href="https://github.com/utkarsh-1602/nft_gallery" target="_blank" className="button">Github</a>
                </div>

                <div className="projects__card">
                    <h3>ICO(Initial Coin Offering) Tokens</h3>
                    <img src={icotoken} alt="Compound Landing Page" />
                    <p>Created token for my own NFT Collection CryptoDevs. Where the cryptodevs NFT holders will get 10 free tokens, but they would have to pay Gas fees for it. A full Website is created where users can visit for the ICO (Initial Coin Offering).
                    </p>

                    <a href="https://ico-cryptodevtoken-2022-n9vwqyzqw-utkarsh-1602.vercel.app/" target="_blank" className="button">Site</a>
                    <a href="https://github.com/utkarsh-1602/token_for_nftcollection_ICO_2022" target="_blank" className="button">Github</a>
                </div>

                <div className="projects__card">
                    <h3>Sorting Visualizer</h3>
                    <img src={sortingvisualizer} alt="Aave Landing Page" />
                    <p>Visualization of common sorting algorithms: QuickSort, MergeSort, HeapSort, BubbleSort, InsertionSort. Technologies used - React.js
                    </p>

                    <a href="https://chillmusic.vercel.app/" target="_blank" className="button">Site</a>
                    <a href="https://github.com/utkarsh-1602/React-Lofi-Music-App" target="_blank" className="button">Github</a>
                </div>

                <div className="projects__card">
                    <h3>Lofi-Music App</h3>
                    <img src={lofiapp} alt="Aave Landing Page" />
                    <p>A Lofi-Music App , where you can listen lofi-music's while Coding or Doing any of your Work. Made using React .js as Front-end and Styling using SASS, and Deployed on Vercel
                    </p>

                    <a href="https://netflix-clone-c1d96.web.app/" target="_blank" className="button">Site</a>
                    <a href="https://github.com/utkarsh-1602/Netflix-Clone-2021" target="_blank" className="button">Github</a>
                </div>

                <div className="projects__card">
                    <h3>Netflix Clone</h3>
                    <img src={netflixclone} alt="Aave Landing Page" />
                    <p>Netflix UI clone application project. It fetches the movie data from a third-party API. It also has trailer pop-ups functionality implemented into it.The clone has been built using React JS, Redux, React-hooks, Styled-component, Material-UI, TMDB API, and Firebase (hosting & Deploying). ❄
                    </p>

                    <a href="https://netflix-clone-c1d96.web.app/" target="_blank" className="button">Site</a>
                    <a href="https://github.com/utkarsh-1602/Netflix-Clone-2021" target="_blank" className="button">Github</a>
                </div>
                
                
            </div>
        </section>
    );
}

export default Projects;